/**
 * The facts about a Mystic that the profile rail prints as a label/value list:
 * when and where they were born, who made them, how much they have read.
 * Rows with nothing to say are left out rather than printed empty.
 */
export function bornLine (d) {
  if (!d) return ''
  const parts = []
  if (d.birth_date) {
    const dt = new Date(`${d.birth_date}T00:00:00`)
    if (!isNaN(dt)) parts.push(`${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()}`)
  }
  const loc = [d.reader_city, d.reader_state].filter(Boolean).join(', ')
  if (loc) parts.push(loc)
  return parts.join(' · ')
}

export function readerFacts (d) {
  if (!d) return []
  const rows = []
  const born = bornLine(d)
  if (born) rows.push({ label: 'Born', value: born })
  if (d.authored_by) {
    const row = { label: 'Created by', value: d.authored_by }
    if (d.authored_by_website) row.href = d.authored_by_website
    rows.push(row)
  }
  if (d.stats || d.followers_count !== undefined) {
    const readings = d.stats?.reading_count || 0
    const shared = d.stats?.shared_count || 0
    const followers = d.followers_count || 0
    rows.push({ label: 'Readings', value: `${readings} · ${shared} shared · ${followers} follower${followers === 1 ? '' : 's'}` })
  }
  return rows
}
